<p-toast></p-toast>

<div class="dashboard-wrapper">
  <!-- ===== Welcome Banner ===== -->
  <div class="welcome-banner">
    <div class="welcome-text">
      <h1>Welcome back 👋</h1>
      <p>Here's what's happening with your store today.</p>
    </div>
    <div class="banner-decoration">
      <div class="deco-circle c1"></div>
      <div class="deco-circle c2"></div>
      <div class="deco-circle c3"></div>
    </div>
  </div>

  <!-- ===== Stats Cards ===== -->
  <div class="stats-grid">

    <!-- Orders Card -->
    <div class="stat-card orders-card" routerLink="/panel/orders/ordersList" routerLinkActive="route-active">
      <div class="card-glow"></div>
      <div class="card-content">
        <div class="card-header">
          <div class="card-icon orders-icon">
            <i class="pi pi-shopping-cart"></i>
          </div>
          <div class="card-trend up">
            <i class="fa fa-spinner fa-spin"></i>
            <span>{{ orderProcessingCount }}</span>
          </div>
        </div>
        <div class="card-body">
          <div class="card-value">{{ ordersCount | number }}</div>
          <div class="card-label">Total Orders</div>
        </div>
        <div class="card-footer">
          <div class="mini-bar-chart">
            <span class="bar" style="height:40%"></span>
            <span class="bar" style="height:65%"></span>
            <span class="bar" style="height:50%"></span>
            <span class="bar" style="height:80%"></span>
            <span class="bar" style="height:55%"></span>
            <span class="bar" style="height:90%"></span>
            <span class="bar active" style="height:75%"></span>
          </div>
          <span class="card-subtitle">vs last month</span>
        </div>
      </div>
    </div>

    <!-- Users Card -->
    <div class="stat-card users-card" routerLink="/panel/users/usersList" routerLinkActive="route-active">
      <div class="card-glow"></div>
      <div class="card-content">
        <div class="card-header">
          <div class="card-icon users-icon">
            <i class="pi pi-users"></i>
          </div>
          <!-- <div class="card-trend up">
            <i class="pi pi-arrow-up-right"></i>
            <span>+8%</span>
          </div> -->
        </div>
        <div class="card-body">
          <div class="card-value">{{ userCounts | number }}</div>
          <div class="card-label">Active Users</div>
        </div>
        <div class="card-footer">
          <div class="mini-bar-chart">
            <span class="bar" style="height:55%"></span>
            <span class="bar" style="height:70%"></span>
            <span class="bar" style="height:45%"></span>
            <span class="bar" style="height:85%"></span>
            <span class="bar" style="height:60%"></span>
            <span class="bar" style="height:75%"></span>
            <span class="bar active" style="height:90%"></span>
          </div>
          <span class="card-subtitle">vs last month</span>
        </div>
      </div>
    </div>

    <!-- Products Card -->
    <!-- <div class="stat-card products-card" routerLink="/panel/products/products">
      <div class="card-glow"></div>
      <div class="card-content">
        <div class="card-header">
          <div class="card-icon products-icon">
            <i class="pi pi-th-large"></i>
          </div>
          <div class="card-trend up">
            <i class="pi pi-arrow-up-right"></i>
            <span>+24%</span>
          </div>
        </div>
        <div class="card-body">
          <div class="card-value">{{ 842 | number }}</div>
          <div class="card-label">Products Listed</div>
        </div>
        <div class="card-footer">
          <div class="mini-bar-chart">
            <span class="bar" style="height:35%"></span>
            <span class="bar" style="height:55%"></span>
            <span class="bar" style="height:70%"></span>
            <span class="bar" style="height:50%"></span>
            <span class="bar" style="height:80%"></span>
            <span class="bar" style="height:65%"></span>
            <span class="bar active" style="height:95%"></span>
          </div>
          <span class="card-subtitle">vs last month</span>
        </div>
      </div>
    </div> -->

    <!-- Revenue Card -->
    <div class="stat-card revenue-card">
      <div class="card-glow"></div>
      <div class="card-content">
        <div class="card-header">
          <div class="card-icon revenue-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <div class="card-trend up">
            <i class="fa fa-spinner fa-spin"></i>
            <span>{{ topUpProcessingCount }}</span>
          </div>
        </div>
        <div class="card-body">
          <div class="card-value">{{topUpOrdersCount | number}}</div>
          <div class="card-label">Top-up Orders</div>
        </div>
        <div class="card-footer">
          <div class="mini-bar-chart">
            <span class="bar" style="height:60%"></span>
            <span class="bar" style="height:45%"></span>
            <span class="bar" style="height:75%"></span>
            <span class="bar" style="height:55%"></span>
            <span class="bar" style="height:85%"></span>
            <span class="bar" style="height:70%"></span>
            <span class="bar active" style="height:92%"></span>
          </div>
          <span class="card-subtitle">vs last month</span>
        </div>
      </div>
    </div>

    <!-- Team Work Card -->
    <!-- <div class="stat-card team-card" routerLink="/dashboard/teamWork">
      <div class="card-glow"></div>
      <div class="card-content">
        <div class="card-header">
          <div class="card-icon team-icon">
            <i class="pi pi-users"></i>
          </div>
          <div class="card-trend neutral">
            <i class="pi pi-minus"></i>
            <span>Stable</span>
          </div>
        </div>
        <div class="card-body">
          <div class="card-value">{{ 14 }}</div>
          <div class="card-label">Team Members</div>
        </div>
        <div class="card-footer">
          <div class="member-avatars">
            <div class="avatar-circle" style="background: #0085FF;">A</div>
            <div class="avatar-circle" style="background: #8b5cf6;">M</div>
            <div class="avatar-circle" style="background: #06b6d4;">S</div>
            <div class="avatar-circle more">+11</div>
          </div>
          <span class="card-subtitle">online now</span>
        </div>
      </div>
    </div> -->

    <!-- Tickets Card -->
    <div class="stat-card tickets-card" routerLink="/panel/tickets/ticket-list">
      <div class="card-glow"></div>
      <div class="card-content">
        <div class="card-header">
          <div class="card-icon tickets-icon">
            <i class="pi pi-ticket"></i>
          </div>
          <div class="count-trades">
            <div class="card-trend up mb-2">
              <i class="pi pi-lock-open"></i>
              <span>{{ ticketCounts?.open }}</span>
            </div>
            <div class="card-trend down">
              <i class="pi pi-lock"></i>
              <span>{{ ticketCounts?.closed }}</span>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="card-value" *ngIf="ticketCounts">{{ ticketCounts!.open + ticketCounts!.closed }}</div>
          <div class="card-label">Open Tickets</div>
        </div>
        <div class="card-footer">
          <div class="ticket-status">
            <div class="status-dot open"></div><span>Open</span>
            <div class="status-dot closed" style="margin-left:10px"></div><span>Closed</span>
          </div>
          <span class="card-subtitle">needs attention</span>
        </div>
      </div>
    </div>

  </div>

  <!-- ===== Bottom Section ===== -->
  <div class="bottom-section">

    <!-- Quick Actions -->
    <div class="quick-actions-panel">
      <div class="panel-header">
        <h3><i class="pi pi-bolt"></i> Quick Actions</h3>
      </div>
      <div class="actions-grid">
        <div class="action-btn" routerLink="/panel/products/new-product/form">
          <div class="action-icon" style="background: linear-gradient(135deg, #667eea, #764ba2)">
            <i class="pi pi-plus"></i>
          </div>
          <span>New Product</span>
        </div>
        <div class="action-btn" routerLink="/panel/orders/ordersList">
          <div class="action-icon" style="background: linear-gradient(135deg, #f093fb, #f5576c)">
            <i class="pi pi-list"></i>
          </div>
          <span>View Orders</span>
        </div>
        <div class="action-btn" routerLink="/panel/wallets/wallets-list">
          <div class="action-icon" style="background: linear-gradient(135deg, #4facfe, #00f2fe)">
            <i class="pi pi-wallet"></i>
          </div>
          <span>Wallets</span>
        </div>
        <div class="action-btn" routerLink="/panel/reports">
          <div class="action-icon" style="background: linear-gradient(135deg, #43e97b, #38f9d7)">
            <i class="pi pi-chart-bar"></i>
          </div>
          <span>Reports</span>
        </div>
        <div class="action-btn" routerLink="/panel/notifications">
          <div class="action-icon" style="background: linear-gradient(135deg, #fa709a, #fee140)">
            <i class="pi pi-bell"></i>
          </div>
          <span>Notifications</span>
        </div>
        <div class="action-btn" routerLink="/panel/setting/profile">
          <div class="action-icon" style="background: linear-gradient(135deg, #a18cd1, #fbc2eb)">
            <i class="pi pi-user"></i>
          </div>
          <span>Profile</span>
        </div>
        <div class="action-btn" routerLink="/panel/activity-log">
          <div class="action-icon" style="background: linear-gradient(135deg, #ff0000, #facfcf)">
            <i class="pi pi-clock"></i>
          </div>
          <span>Activity Logs</span>
        </div>
      </div>
    </div>

    <!-- Recent Activity -->
    <div class="activity-panel">
      <div class="panel-header">
        <h3><i class="pi pi-clock"></i> Recent Activity</h3>
        <span class="view-all" routerLink="/panel/activity-log">View All</span>
      </div>
      <div class="activity-list">
        <div class="activity-item" *ngFor="let activity of activitiesLog?.data">
          <div class="activity-dot" [ngClass]="getModuleClass(activity.module)"></div>
          <div class="activity-info">
            <span class="activity-title" [innerHTML]="activity.description | safehtml"></span>
            <span class="activity-time">{{ getTimeAgo(activity.createdAt) }}</span>
          </div>
          <div class="activity-badge" [ngClass]="getActionBadgeClass(activity.action)">
            {{ activity.action }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
